import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-sage text-center" data-id="element-58">
      <div className="max-w-4xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-60">
          <h2 className="font-serif text-4xl md:text-6xl text-warm-white mb-6 leading-tight" data-id="element-61">
            TU SALUD EMPIEZA CON LO QUE COMÉS 💚
          </h2>
          <p className="text-xl md:text-2xl text-cream/90 mb-10 font-medium" data-id="element-62">
            Empezá hoy una vida más saludable y organizada sin gluten
          </p>
          <Button href="#precio" variant="secondary" className="md:px-12 md:py-5 text-lg md:text-xl" data-id="element-63">
            QUIERO MI ALIMENTACIÓN SALUDABLE AHORA
          </Button>
        </motion.div>
      </div>
    </section>;
}